import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "types/store";
import styles from "components/LanguageModelArtifact/style.module.css";
import { Button } from "aible";
import * as contentGenerationReducer from "containers/ContentGeneration/reducer";
import * as viewReducer from "containers/View/reducer";
import * as aiServiceReducer from "containers/AiService/reducer";
import { AutoSizer, Table, Column } from "react-virtualized";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { getSelectedFolder } from "containers/Folders/reducer";
import { getChatApp } from "containers/ChatGPT/reducer";
import MarkdownPanel from "components/ChatGPT/MarkdownPanel";
import * as chatAppReducer from "containers/ChatApp/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
import Toggle from "components/Inputs/Toggle/Toggle";
import { LineInput } from "components/Inputs/LineInput";
import * as nextReducer from "@/containers/Next/NextReducer";
import { FEEDBACK_BREAKPOINTS } from "@/containers/LanguageModelArtifact/reducer";
import ModelSelector from "@/components/ChatGPT/ModelSelector";
const EditExampleSetModal = ({ showModal, updateShowModal, selectedExampleSetId, updateSelectedExampleSetId, synthDataCount, dataGenerationModelId, onComplete }) => {
    const dispatch = useDispatch();
    const [isCreatingData, updateIsCreatingData] = useState(false);
    const [isLoadingResultIds, updateIsLoadingResultIds] = useState(false);
    const [localCreateSynthData, updateLocalCreateSynthData] = useState(false);
    const [localDataGenerationModelId, updateLocalDataGenerationModelId] = useState();
    const [localSynthDataCount, updateLocalSynthDataCount] = useState(FEEDBACK_BREAKPOINTS.MIN);
    const folderId = useSelector((state) => getSelectedFolder(state));
    const chatApp = useSelector((state) => getChatApp(state));
    const selectedFolderId = useSelector((state) => foldersReducer.getSelectedFolder(state));
    const exampleSetSelector = useSelector((state) => contentGenerationReducer.getExampleSets(state));
    const exampleSets = contentGenerationReducer.filterExampleSets(exampleSetSelector, selectedFolderId);
    const selectedExampleSet = exampleSets?.find((exampleSet) => exampleSet?.id === selectedExampleSetId);
    useEffect(() => {
        if (synthDataCount !== undefined) {
            let newCreateSynthData = synthDataCount > 0;
            if (localCreateSynthData !== newCreateSynthData) {
                updateLocalCreateSynthData(newCreateSynthData);
            }
            if (synthDataCount !== localSynthDataCount) {
                updateLocalSynthDataCount(synthDataCount);
            }
        }
    }, [synthDataCount]);
    const retSynthDataCount = synthDataCount ? synthDataCount : localCreateSynthData ? localSynthDataCount : 0;
    const retDataGenerationModel = dataGenerationModelId ?? localDataGenerationModelId;
    useEffect(() => {
        if (selectedExampleSetId && selectedExampleSet && !selectedExampleSet?.result_ids) {
            updateIsLoadingResultIds(true);
            dispatch(contentGenerationReducer.fetchExampleSetViewAndUpdate(selectedExampleSetId))
                .then(() => {
                updateIsLoadingResultIds(false);
            })
                .catch(() => {
                console.log("Could not fetch result_ids");
            });
        }
    }, [selectedExampleSetId, exampleSets]);
    const handleCreateCopyWithSyntheticData = async () => {
        updateIsCreatingData(true);
        console.log("Creating copy with synthetic data");
        const selectedExecutions = selectedExampleSet?.result_ids;
        if (!selectedExecutions?.length) {
            return;
        }
        const currentDate = new Date().toLocaleString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        });
        const trainingDataName = "New Training Data - " + currentDate;
        const exampleSetCreate = {
            name: trainingDataName,
            description: "",
            metadata: {},
            folder_id: folderId
        };
        const newExampleset = await dispatch(contentGenerationReducer.createExampleSet(exampleSetCreate));
        console.log("Created example set: ", newExampleset);
        console.log("Adding examples to example set: ", selectedExecutions, newExampleset);
        dispatch(contentGenerationReducer.addExecutionsToExampleSet(newExampleset?.id, selectedExecutions)).finally(async () => {
            try {
                if (retSynthDataCount > 0 && retDataGenerationModel) {
                    await dispatch(contentGenerationReducer.addSyntheticDataToExampleSet(newExampleset?.id, retDataGenerationModel, retSynthDataCount));
                }
            }
            catch (e) { }
            try {
                if (chatApp?.id && newExampleset?.id) {
                    await dispatch(chatAppReducer.addTrainingDatasetToChatApp(chatApp.id, newExampleset.id));
                }
            }
            catch (e) {
                console.log(e);
            }
            updateShowModal(false);
            if (onComplete) {
                const newModel = await dispatch(nextReducer.handleTrainFineTuning(undefined, newExampleset));
                onComplete();
            }
            return updateIsCreatingData(false);
        });
    };
    const handleResetLocalSettings = () => {
        updateLocalSynthDataCount(FEEDBACK_BREAKPOINTS.MIN);
        updateLocalDataGenerationModelId(undefined);
        updateLocalCreateSynthData(false);
    };
    const handleCloseModal = () => {
        updateShowModal(false);
        handleResetLocalSettings();
        updateSelectedExampleSetId(undefined);
    };
    return (React.createElement(Dialog, { open: showModal, onOpenChange: () => {
            handleCloseModal();
        } },
        React.createElement(DialogContent, { size: "xl" },
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, selectedExampleSet
                    ? `Review and Confirm Post Training Data: ${selectedExampleSet.name}`
                    : `Review and Confirm Post Training Data`)),
            React.createElement(React.Fragment, null,
                React.createElement(React.Fragment, null,
                    React.createElement(ExampleSetResponsesTable, { isLoadingResultIds: isLoadingResultIds, selectedExampleSetId: selectedExampleSetId }),
                    synthDataCount === undefined ? (React.createElement("div", null,
                        React.createElement("div", { className: styles.synthDataText, style: { marginBottom: "6px" } },
                            React.createElement(Toggle, { checked: localCreateSynthData, onChange: () => {
                                    updateLocalCreateSynthData(!localCreateSynthData);
                                }, isAibleColors: true }),
                            React.createElement("div", { style: { marginLeft: "6px" } },
                                React.createElement("strong", null, "Add synthetic data? "),
                                React.createElement("span", null, "This data will be based off your current feedback"))),
                        localCreateSynthData ? (React.createElement("div", { className: styles.synthDataText, style: { height: "31px" } },
                            React.createElement("div", null, "Create"),
                            React.createElement("div", { style: { width: "100px", margin: "0px 6px" } },
                                React.createElement(LineInput, { value: localSynthDataCount, onChange: (v) => {
                                        updateLocalSynthDataCount(Number(v) || 0);
                                    } })),
                            React.createElement("div", null, "additional rows of synthetic data"))) : (React.createElement("div", { style: { height: "31px" } })),
                        localCreateSynthData ? (React.createElement("div", { style: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                marginBottom: "10px",
                                justifyContent: "space-between"
                            } },
                            React.createElement("div", null, "Model for Data Generation"),
                            React.createElement("div", null,
                                React.createElement(ModelSelector, { modelId: localDataGenerationModelId, updateModelId: updateLocalDataGenerationModelId, hideIcons: true, isCreatable: true, selectorStyle: {
                                        minWidth: "159px"
                                    }, forceModelId: true, menuPlacement: "top" })))) : (React.createElement("div", { style: { height: "31px" } })))) : synthDataCount && synthDataCount > 0 ? (React.createElement("div", null, `${synthDataCount} additional rows of data will be automatically generated.`)) : null)),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { onClick: () => {
                        handleCloseModal();
                    } }, "Back"),
                localCreateSynthData && (React.createElement(Button, { onClick: () => {
                        handleCreateCopyWithSyntheticData();
                    }, disabled: Boolean(!retDataGenerationModel || localSynthDataCount < 1), isLoading: isCreatingData }, "Create New Training Data with Synthetic Data"))))));
};
const ExampleSetResponsesTable = ({ isLoadingResultIds, selectedExampleSetId }) => {
    const dispatch = useDispatch();
    const [isLoadingResults, updateIsLoadingResults] = useState(false);
    const selectedFolderId = useSelector((state) => foldersReducer.getSelectedFolder(state));
    const exampleSetSelector = useSelector((state) => contentGenerationReducer.getExampleSets(state));
    const exampleSets = contentGenerationReducer.filterExampleSets(exampleSetSelector, selectedFolderId);
    const selectedExampleSet = exampleSets?.find((exampleSet) => exampleSet?.id === selectedExampleSetId);
    const exampleSetResultIds = selectedExampleSet?.result_ids;
    const resultsWithData = useSelector((state) => contentGenerationReducer.getResultData(state));
    const exampleSetResults = exampleSetResultIds
        ?.map((ids) => resultsWithData?.[ids])
        .filter((data) => data !== undefined);
    const aiServiceModels = useSelector((state) => aiServiceReducer.getModels(state));
    const exampleSetResultData = exampleSetResults?.map((result) => {
        const combinedQuery = result.data.input.messages.map((message) => message.content).join("");
        const modelId = result.data.input.generation_config.model_id;
        let modelString = result.data.input.generation_config.model;
        if (modelId && !isNaN(modelId)) {
            modelString = Object.values(aiServiceModels).find((model) => model?.id === modelId)?.name ?? modelString;
        }
        const resultDataAcc = result.data.input.messages.reduce((messageAcc, currentMsg) => {
            if (currentMsg.reference_data === undefined) {
                return messageAcc;
            }
            for (const dataItem of currentMsg.reference_data) {
                if (dataItem.type === "CORPUS") {
                    for (const document of dataItem.documents) {
                        const currentArtifactId = document.metadata.artifact_id;
                        if (currentArtifactId !== undefined) {
                            messageAcc.artifacts.add(currentArtifactId);
                        }
                    }
                }
                else if (dataItem.type === "DATASET_QUERY") {
                    messageAcc.datasets.add(dataItem.dataset_id);
                }
                else if ("charts" in dataItem) {
                    for (const chart of dataItem.charts) {
                        messageAcc.datasets.add(chart.dataset_id);
                    }
                }
            }
            return messageAcc;
        }, {
            artifacts: new Set(),
            datasets: new Set()
        });
        const itemData = {
            query: combinedQuery,
            response: result?.data?.output?.content,
            result_id: result?.id,
            modelId: modelString,
            resultData: {
                artifacts: Array.from(resultDataAcc.artifacts),
                datasets: Array.from(resultDataAcc.datasets)
            },
            taskName: result?.task_name
        };
        return itemData;
    });
    useEffect(() => {
        if (selectedExampleSetId && exampleSetResultIds?.length && !isLoadingResultIds) {
            updateIsLoadingResults(true);
            exampleSetResultIds?.forEach((id) => {
                dispatch(contentGenerationReducer.fetchResultByIdAndUpdate(id)).then((response) => {
                    return response;
                });
            });
            updateIsLoadingResults(false);
        }
    }, [selectedExampleSetId, isLoadingResultIds]);
    const columns = [
        { label: "Query", dataKey: "query", width: 500 },
        { label: "Response", dataKey: "response", width: 600 },
        { label: "Model", dataKey: "modelId", width: 160 },
        { label: "Data", dataKey: "resultData", width: 180 }
    ];
    if (!selectedExampleSetId) {
        return React.createElement(React.Fragment, null);
    }
    if (isLoadingResultIds || isLoadingResults) {
        return (React.createElement("div", null,
            React.createElement(LoadingIndicator, null)));
    }
    return (React.createElement("div", null,
        React.createElement("div", { style: { height: "500px" } },
            React.createElement(AutoSizer, null, ({ width, height }) => (React.createElement(Table, { width: width, height: height, headerHeight: 30, rowHeight: 180, rowCount: exampleSetResultData?.length ?? 0, rowGetter: ({ index }) => exampleSetResultData?.[index], rowClassName: styles.responseDataRow, className: undefined, headerClassName: styles.responseDataColumn }, columns.map((column, index) => {
                if (column.dataKey === "response" || column.dataKey === "query" || column.dataKey === "modelId") {
                    return (React.createElement(Column, { key: index, label: column.label, dataKey: column.dataKey, width: column.width, cellRenderer: ({ cellData }) => (React.createElement("div", { className: styles.responseDataResponseCell },
                            React.createElement(MarkdownPanel, null, cellData))), className: styles.responseDataColumn }));
                }
                if (column.dataKey === "resultData") {
                    return (React.createElement(Column, { key: index, label: column.label, dataKey: column.dataKey, width: column.width, cellRenderer: ({ cellData }) => (React.createElement("div", { className: styles.responseDataResponseCell },
                            React.createElement(DatasetsList, { dataList: cellData.datasets, type: "datasets" }),
                            React.createElement(DatasetsList, { dataList: cellData.artifacts, type: "artifacts" }))), className: styles.responseDataColumn }));
                }
                return (React.createElement(Column, { key: index, label: column.label, dataKey: column.dataKey, width: column.width, className: styles.responseDataColumn }));
            })))))));
};
const DatasetsList = ({ dataList, type }) => {
    const datasets = useSelector((state) => viewReducer.getDatasets(state, undefined, undefined, true)) ?? [];
    const corpusList = useSelector((state) => viewReducer.getCorpusList(state, true)) ?? [];
    const results = dataList.map((item) => {
        if (type === "datasets") {
            const foundDataset = datasets.find((d) => d.id === item);
            return foundDataset?.name;
        }
        if (type === "artifacts") {
            const foundArtifact = corpusList.find((c) => c.id === item);
            return foundArtifact?.name;
        }
    });
    return React.createElement("div", null, results);
};
export default EditExampleSetModal;
